import cookieUtils from "@/utils/Cookies";
import urls from "../helpers/url_helpers";
import {
  post,
  get,
  del,
  put,
  ORBITAL_API_URL,
  fluxGet,
} from "../helpers/api_helpers";
import { withRetryHandling } from "../utils/retry-handling";

const config = {
  headers: { Authorization: `Bearer ${cookieUtils.get("token")}` },
};

export async function createcart(data, config) {
  return await post(
    `${urls.CREATE_CART}/${data.buyerId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function clearcart(data, config) {
  return await post(
    `${urls.CLEAR_CART}/${data.buyerId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}
export async function updatecart(data, config) {
  return await post(
    `${urls.UPDATE_CART}/${data.buyerId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}
export async function removecart(data, config) {
  return await post(
    `${urls.REMOVE_CART}/${data.id}/${data.buyerId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function sendCartLink(data) {
  return await post(
    `${urls.SEND_CART_LINK}/${data.buyerId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function applyDiscount(data) {
  return await post(
    `${urls.APPLY_DISCOUNT}/${data?.businessId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function getcart(data) {
  return await get(`${urls.GET_CART}/${data}`, config, ORBITAL_API_URL);
}

export async function addshipping(data) {
  return await post(
    `${urls.ADD_SHIPPING_ADDRESS}/${data.busininessId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function editshipping(data) {
  return await post(
    `${urls.EDIT_SHIPPING_ADDRESS}/${data.busininessId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function setdefaultaddress(data) {
  return await post(
    `${urls.DEFAULT_SHIPPING_ADDRESS}/${data.id}/${data.buyerId}`,
    "",
    config,
    ORBITAL_API_URL
  );
}

export const getalladdress = withRetryHandling((data) => {
  return get(`${urls.GET_SHIPPING_ADDRESS}/${data}`, config, ORBITAL_API_URL);
});

export async function deleteAddress(data) {
  return await post(
    `${urls.DELETE_SHIPPING}/${data.id}/${data.buyerId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function confirmpurchase(data) {
  return await post(
    `${urls.CONFIRM_PURCHASE}/${data.buyerId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function addressSearch(data) {
  return await fluxGet(`${urls.ADDRESS_SEARCH}`, data, config);
}
export async function placeSuggestion(data) {
  return await fluxGet(
    `${urls.PLACE_SUGGESTION}?${new URLSearchParams(data)}`,
    config
  );
}

export const getallpickuplocations = withRetryHandling((data) => {
  return get(`${urls.GET_PICKUP_ADDRESS}/${data}`, config, ORBITAL_API_URL);
});

export async function deletePickupLocation(data) {
  return await del(
    `${urls.DELETE_PICKUP}/${data.id}/${data.businessId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}
export async function addPickupLocation(data) {
  return await post(
    `${urls.ADD_PICKUP_ADDRESS}/${data.businessId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}

export async function editPickupLocation(data) {
  return await put(
    `${urls.EDIT_PICKUP_ADDRESS}/${data.id}/${data.businessId}`,
    data,
    config,
    ORBITAL_API_URL
  );
}
export async function shippingBreakdown(data) {
  return await get(
    `${urls.SHIPPONG_COST_BREAKDOWN}/${data}`,
    config,
    ORBITAL_API_URL
  );
}

export async function confirmpayment(data) {
  return await post(`${urls.CONFIRM_PAYMENT}`, data, config, ORBITAL_API_URL);
}

export async function clearShipping(data) {
  return await get(
    `${urls.CLIENT_CLEAR_SHIPPING}/${data}`,
    config,
    ORBITAL_API_URL
  );
}
